import React from 'react'
import ProductionMethodsPage from './ProductionMethodsPage'
import '../styles/index.scss'

function ProductionMethodsContainer() {
    return (
        <div className='ProductionMethodsContainer'>
            <ProductionMethodsPage />
        </div>
    )
}

export default ProductionMethodsContainer